var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',[_c('h1',{staticClass:"text-h3"},[_vm._v("Dashboard")])])],1),_c('v-row')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }